import { toZonedTime } from 'date-fns-tz';
import { isBefore, isSameDay } from 'date-fns';

export const getRangeError = (value, isRange, timezone = null) => {
  if (!isRange || !Array.isArray(value)) return null;
  const [start, end] = value;
  if (!start || !end) return null;
  const startDate = timezone ? toZonedTime(start, timezone) : new Date(start);
  const endDate = timezone ? toZonedTime(end, timezone) : new Date(end);
  if (!isBefore(endDate, startDate)) return null;
  return isSameDay(startDate, endDate)
    ? 'End time must be after the start time'
    : 'End date must be after the start date';
};
